import BaseFilter from './BaseFilter';
import { requestGetQuantityTypes as request } from '../../../state/ducks/filters/api';

const QuantityTypeFilter = ({ value, requestQueryParams, onChange }) => BaseFilter({
  value, onChange, request, requestQueryParams, 
  preloadOptions: true 
});

QuantityTypeFilter.defaultProps = BaseFilter.defaultProps;

export default QuantityTypeFilter;
